<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addWifi"
            >添加WIFI</el-button
          >
        </div>
        <!-- <div class="header-right">
          <div>
            <span>消息类型：</span>
            <el-select
              popper-class="screen-select"
              v-model="msgContentType"
              size="small"
              placeholder="请选择消息类型"
            >
              <el-option
                v-for="item in msgContentTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <span>推送类型：</span>
            <el-select
              v-model="msgPushType"
              size="small"
              placeholder="请选择推送类型"
            >
              <el-option
                v-for="item in msgPushTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <span>消息发送状态：</span>
            <el-select
              v-model="sendMsgStatus"
              size="small"
              placeholder="请选择消息发送状态"
            >
              <el-option
                v-for="item in sendMsgStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div> -->
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="wifiList" style="width: 100%;">
            <el-table-column label="WIFI名称（SSID）" align="left">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.wifiName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="WIFI密码" align="left">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.password }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="edit(scope.$index)"
                  plain
                  >编辑</el-button
                >
                <el-button
                  size="small"
                  type="danger"
                  @click="del(scope.$index)"
                  plain
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogcreateWifiVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="dialogClose"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        添加消息
      </div>
      <el-form
        :model="createWifiForm"
        :rules="createWifiFormRule"
        ref="createWifiForm"
        label-width="158px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="WIFI名称（SSID）" prop="wifiName">
          <el-input
            v-model="createWifiForm.wifiName"
            placeholder="请填写WIFI名称（SSID）"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="WIFI密码" prop="password">
          <el-input
            v-model="createWifiForm.password"
            placeholder="请填写WIFI密码"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createWifi" :loading="isSubmit">{{
          createWifiForm.wifiListId ? "立即编辑" : "立即创建"
        }}</el-button>
        <el-button @click="dialogcreateWifiVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getWifiList,
  getWifiListCount,
  addAndUpdateWifiList,
  deleteWifiList
} from "@/api/index.js";
export default {
  data() {
    return {
      msgContentType: "",
      msgPushType: "",
      wifiList: [],
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      dialogVisible: false,
      dialogImageUrl: "",
      dialogcreateWifiVisible: false,
      createWifiForm: {
        wifiName: "",
        password:""
      },
      createWifiFormRule: {
        wifiName: [
          {
            required: true,
            message: "请填写WIFI名称（SSID） ",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请填写WIFI密码 ",
            trigger: "blur",
          },
            { min: 8, message: '密码长度不能少于8位', trigger: 'blur' }
        ],
      },
      isSubmit: false,
    };
  },
  watch: {
  },
  computed: {
  },
  mounted() {
    if (this.$route.query.type == "addWifi") {
      this.addWifi();
    }
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getWifiList();
      // this.getWifiListCount();
    },
    getWifiList() {
      getWifiList({
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data.totalCount;
          this.wifiList = res.data.list;
        }
        if (res.code == -1) {
          this.wifiList = [];
        }
      });
    },
    getWifiListCount() {
      getWifiListCount().then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getWifiList();
    },
    dialogClose() {
      (this.createWifiForm = {
        wifiName: "",
        password:""
      }),
        this.$refs.createWifiForm.resetFields();
    },
    addWifi() {
      this.dialogcreateWifiVisible = true;
    },
    createWifi() {
      this.$refs.createWifiForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.createWifiForm));
          addAndUpdateWifiList(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: params.wifiListId?"编辑成功" :"创建成功",
                type: "success",
                duration: 2000,
              });
              this.dialogcreateWifiVisible = false;
              this.getPageData();
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            setTimeout(() => {
              this.isSubmit = false;
            }, 500);
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    edit(index) {
      let params = JSON.parse(JSON.stringify(this.wifiList[index]));
      this.createWifiForm = {
        wifiName: params.wifiName,
        password: params.password,
        wifiListId:params.id

      };
      this.dialogcreateWifiVisible = true;
    },
    del(index) {
      deleteWifiList({
        wifiListId: this.wifiList[index].id,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "删除成功",
            type: "success",
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-right {
    & > div {
      margin-left: 20px;
    }
  }
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
      cursor: pointer;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
.screen-select {
  width: 200px;
}
</style>
